// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Json_decode from "../../../../../../../../node_modules/@glennsl/bs-json/src/Json_decode.mjs";
import * as PnMShiftingType$PorterinFeature from "../../types/PnMShiftingType.mjs";

function execute(json) {
  var shifting_type = Json_decode.at({
          hd: "shifting_type",
          tl: {
            hd: "type",
            tl: /* [] */0
          }
        }, Json_decode.string)(json);
  var geo_region_id = Json_decode.optional(Json_decode.at({
            hd: "shifting_type",
            tl: {
              hd: "geo_region_id",
              tl: /* [] */0
            }
          }, Json_decode.$$int), json);
  var pickup_region_id = Json_decode.optional(Json_decode.at({
            hd: "shifting_type",
            tl: {
              hd: "pickup_geo_region_id",
              tl: /* [] */0
            }
          }, Json_decode.$$int), json);
  var drop_region_id = Json_decode.optional(Json_decode.at({
            hd: "shifting_type",
            tl: {
              hd: "drop_geo_region_id",
              tl: /* [] */0
            }
          }, Json_decode.$$int), json);
  return PnMShiftingType$PorterinFeature.fromString(shifting_type, geo_region_id, pickup_region_id, drop_region_id);
}

export {
  execute ,
}
/* No side effect */
